// Map asset status → StatusBadge tone (which uses semantic colors).
export const ASSET_STATUS_BADGE = {
  'in-stock': 'active',
  'assigned': 'placed',
  'under-maintenance': 'pending',
  'lost': 'destructive',
  'damaged': 'destructive',
  'retired': 'inactive',
  'disposed': 'inactive',
  'sold': 'completed',
};

export const ASSET_STATUS_LABEL = {
  'in-stock': 'In Stock',
  'assigned': 'Assigned',
  'under-maintenance': 'Under Maintenance',
  'lost': 'Lost',
  'damaged': 'Damaged',
  'retired': 'Retired',
  'disposed': 'Disposed',
  'sold': 'Sold',
};

export const ASSET_STATUSES = Object.keys(ASSET_STATUS_LABEL);

export const ASSET_CONDITIONS = ['new', 'good', 'fair', 'poor'];

export const DEPRECIATION_METHODS = [
  { value: 'none', label: 'None' },
  { value: 'straight-line', label: 'Straight-Line' },
  { value: 'wdv', label: 'Written-Down Value (WDV)' },
];

export const ASSIGNEE_TYPES = [
  { value: 'admin', label: 'Admin' },
  { value: 'instructor', label: 'Instructor' },
  { value: 'student', label: 'Student' },
  { value: 'branch', label: 'Branch' },
  { value: 'other', label: 'Other' },
];

export const ATTACHMENT_KINDS = [
  { value: 'invoice', label: 'Invoice' },
  { value: 'photo', label: 'Photo' },
  { value: 'manual', label: 'Manual' },
  { value: 'warranty', label: 'Warranty' },
  { value: 'other', label: 'Other' },
];

export function formatCurrency(value, currency = 'INR') {
  if (value == null || isNaN(value)) return '—';
  try {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency,
      maximumFractionDigits: 0,
    }).format(value);
  } catch {
    return `${currency} ${value}`;
  }
}

export function formatDate(d) {
  if (!d) return '—';
  try { return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }); }
  catch { return '—'; }
}
